module.exports = __webpack_public_path__ + "img/nginx.f743a369.png";